module.exports = __webpack_public_path__ + "img/video1.a023a45b.png";